import {JSX, JSXElement, splitProps} from "solid-js";
import css from "./container.module.css";

interface ContainerProps extends JSX.HTMLAttributes<HTMLDivElement> {
    children: JSXElement | JSXElement[];
}

export default function Container(props: ContainerProps) {
    const [local, rest] = splitProps(props, ["class", "children"]);

    return (
        <div
            class={`${css.container} ${local.class || ""}`.trim()}
            {...rest}
        >
            {local.children}
        </div>
    );
}